import { translateFn } from '../../../../utils/translator.helper';
import { html, nothing, TemplateResult } from 'lit';
import { WEB_COMPONENT_INLINE_ROW_ACTIONS } from '../../../../webcomponents.constants';
import { InlineRowActionsWebComponent } from '../../../../grid/uiElements/inlineRowActions';
import { EASMActions } from '../../findingDetails/types';
import { GzTooltipWebComponent } from '../../../../ui/gzTooltip';
import { BaseSpecificDetailsView } from '../../specificDetailViewByType/baseSpecificDetailsView';
import { UNAVAILABLE_DATA } from '../../../types';

export class DiscoveredIpsView extends BaseSpecificDetailsView {
  static getGeneralInfo(data: any, dependencies: any): TemplateResult {
    const menuBtn = window.document.createElement(WEB_COMPONENT_INLINE_ROW_ACTIONS) as InlineRowActionsWebComponent;
    menuBtn.className = 'icon-right-action';
    menuBtn.inlineActions = [
      {
        title: translateFn('Copy to clipboard'),
        value: EASMActions.COPY_TO_CLIPBOARD_IP,
      },
      {
        title: translateFn('View incidents'),
        value: EASMActions.VIEW_INCIDENTS_IP,
      },
    ];

    if (!data.canPivotToIncidents) {
      menuBtn.disabled = true;
    }

    const menuBtnTooltip = new GzTooltipWebComponent();
    menuBtnTooltip.tooltipText = translateFn('EDR license required');
    menuBtnTooltip.appendChild(menuBtn);
    return html`
      <gz-labeled-content label="${translateFn('IP')}" class="labeled-row" labelFontSize="14">
        <div class="d-flex align-items-center item-with-action">
          <gz-tooltip tooltipText="${data.ip ?? UNAVAILABLE_DATA}" isEllipsis>${data.ip ?? UNAVAILABLE_DATA}</gz-tooltip>
          ${data.ip ? (data.canPivotToIncidents ? menuBtn : menuBtnTooltip) : nothing}
        </div>
      </gz-labeled-content>
    `;
  }
}
